import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const LoginUIAction = Object.freeze({
    initial: "Initial",
    goToInit: "GoToInit",
    goToDashboard: "GoToDashboard",
    goToOtp: "GoToOtp",
});

const initialState = {
    isLoggingIn: false,
    isEmailError: false,
    isPasswordError: false,
    emailMessage: "",
    passwordMessage: "",
    loginErrorMessage: "",
    action: LoginUIAction.initial,
}

export const createLoginSlice = () => {
    return createSlice({
        name: "login",
        initialState,
        reducers: {
            resetState: () => initialState,
            clearEmailMessage(state) {
                state.emailMessage = "";
            },
            clearPasswordMessage(state) {
                state.passwordMessage = "";
            },
            setUIAction(state, action) {
                state.action = action.payload;
            }
        },
        extraReducers: (builder) => {
            builder
                .addCase(userLogin.pending, (state) => {
                    state.isLoggingIn = true;
                })
                .addCase(userLogin.fulfilled, (state, action) => {
                    state.isLoggingIn = false;
                    //state.goToDashboard = true;
                    const success = action.payload.success;
                    if (success) {
                        //state.goToDashboard = true;
                        state.action = LoginUIAction.goToDashboard;
                    } else {
                        state.loginErrorMessage = action.payload.message;
                        if (state.loginErrorMessage === 'User not verified') {
                            //state.goToOtp = true;
                            state.action = LoginUIAction.goToOtp;
                        }
                    }
                })
                .addCase(userLogin.rejected, (state, action) => {
                    const emailMessage = action.payload?.emailMessage ?? "";
                    const passwordMessage = action.payload?.passwordMessage ?? "";

                    if (emailMessage !== "") {
                        state.emailMessage = emailMessage;
                    }
                    if (passwordMessage !== "") {
                        state.passwordMessage = passwordMessage;
                    }

                    state.isLoggingIn = false;
                });
        },
    });
};

export const userLogin = createAsyncThunk(
    "login/userLogin",
    async (credentials, { rejectWithValue, extra }) => {
        const userRepository = extra.userRepository;
        const { email, password, rememberMe } = credentials;
        const emailVal = email.trim();
        const passwordVal = password.trim();

        let success = true;
        let emailMessage = "";
        let passwordMessage = "";

        if (!emailVal) {
            emailMessage = "Email is required";
            success = false;
        }
        if (!passwordVal) {
            passwordMessage = "Password is required";
            success = false;
        }

        if (!success) {
            return rejectWithValue({ emailMessage, passwordMessage });
        }

        try {
            const result = await userRepository.login(email, password, rememberMe);
            console.log(result)
            return result;
        } catch (error) {
            console.error("API Error:", error);
            return rejectWithValue(error.response?.data || { message: "Login failed" });
        }
    }
);